/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetContactDocumentResponseData,
  GetContactDocumentResponseDataFromJSON,
  GetContactDocumentResponseDataFromJSONTyped,
  GetContactDocumentResponseDataToJSON
} from './GetContactDocumentResponseData'

/**
 *
 * @export
 * @interface GetContactShareDocumentResponse
 */
export interface GetContactShareDocumentResponse {
  /**
   *
   * @type {number}
   * @memberof GetContactShareDocumentResponse
   */
  status?: number
  /**
   *
   * @type {GetContactDocumentResponseData}
   * @memberof GetContactShareDocumentResponse
   */
  data?: GetContactDocumentResponseData
}

export function GetContactShareDocumentResponseFromJSON(json: any): GetContactShareDocumentResponse {
  return GetContactShareDocumentResponseFromJSONTyped(json, false)
}

export function GetContactShareDocumentResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetContactShareDocumentResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetContactDocumentResponseDataFromJSON(json['data'])
  }
}

export function GetContactShareDocumentResponseToJSON(value?: GetContactShareDocumentResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetContactDocumentResponseDataToJSON(value.data)
  }
}
